export const passportData = {
  gender: 'male',
  fullName: {
    label: 'Иванов Матвей Петрович',
    value: 'Иванов Матвей Петрович',
    data: {
      surname: 'Иванов',
      name: 'Матвей',
      patronymic: 'Петрович',
      gender: 'MALE',
      source: null,
      qc: '0',
    },
  },
  birthDate: '21.08.1999',
  birthPlace: 'Москва',
  passportNumber: '1120111111',
  passportIssueDate: '21.09.2020',
  passportIssuedBy: 'ГУ МВД РОССИИ ПО МОСКОВСКОЙ ОБЛ.',
  unitCode: '500-131',
  registrationLocationRoute: '6.83.',
  registrationAddress: {
    value: 'г Москва, ул Нижняя Первомайская, д 10',
    label: 'г Москва, ул Нижняя Первомайская, д 10',
    data: {
      fias_level: '8',
      region_fias_id: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
      region_with_type: 'г Москва',
      city_fias_id: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
      fias_id: '633ee9d8-72f1-49e7-a11e-a424e8e0fc8f',
      city_with_type: 'г Москва',
      street_fias_id: '0bd4ae6f-7679-45e3-9ff3-0d74f06ed08d',
      street_with_type: 'ул Нижняя Первомайская',
      settlement_fias_id: null,
      settlement_with_type: null,
      house_fias_id: '633ee9d8-72f1-49e7-a11e-a424e8e0fc8f',
      house: '10',
    },
  },
  registrationAddressFlat: '1',
  registrationDate: '29.05.2021',
  residenceLocationRoute: '6.83.',
  residenceAddress: {
    value: 'г Москва, ул Нижняя Первомайская, д 10',
    label: 'г Москва, ул Нижняя Первомайская, д 10',
    data: {
      fias_level: '8',
      region_fias_id: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
      region_with_type: 'г Москва',
      city_fias_id: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
      fias_id: '633ee9d8-72f1-49e7-a11e-a424e8e0fc8f',
      city_with_type: 'г Москва',
      street_fias_id: '0bd4ae6f-7679-45e3-9ff3-0d74f06ed08d',
      street_with_type: 'ул Нижняя Первомайская',
      settlement_fias_id: null,
      settlement_with_type: null,
      house_fias_id: '633ee9d8-72f1-49e7-a11e-a424e8e0fc8f',
      house: '10',
    },
  },
  residenceAddressFlat: '1',
  residenceAddressIsRegistration: true,
  region: {
    value: 'г Москва',
    label: 'г Москва',
    data: {
      unrestricted_value: '101000, г Москва',
      fias_level: '1',
      region_fias_id: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
      city_fias_id: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
      settlement_fias_id: null,
      settlement_with_type: null,
      street_fias_id: null,
    },
  },
  regionLocationRoute: '6.83.',
};
